<ng-container *appContactsAppContext>
<div class="contacts-shell">
  <app-collapsible-rail-shell class="contacts-rail" [app]="app">
    <stch-side-bar-teams
      *stchSpaceRerender
      [template]="sidebarTemplate"
      [splitViewKey]="sidebarSplitViewKey.contacts"
    />
  </app-collapsible-rail-shell>

  <app-split-view
    class="contacts-rest"
    side="left"
    key="contactsList"
    [collapsedSize]="25"
    [shadow]="true"
    [magneticSize]="300"
    [withIcon]="true"
    [iconTop]="38"
  >
    <app-contacts-list-container
      split-left-pane
      *stchSpaceRerender
      class="list shadow-lg"
    />

    <div class="full-form shadow-lg" split-right-pane>
      <app-contacts-main-view *stchSpaceRerender />
    </div>
  </app-split-view>

  <ng-template #sidebarTemplate let-team="team">
    <app-contacts-side-bar [team]="team"/>
  </ng-template>
</div>
</ng-container>
